import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationForAdministrationService as ApiAuthenticationService, LoginRequestDto, LoginResponseDto, AdministrationUserDto } from '../api/api.services';
import { JwtHelperService } from '@auth0/angular-jwt';
import { catchError, map } from 'rxjs/operators';
import { Observable, BehaviorSubject, of, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private jwtHelper: JwtHelperService = new JwtHelperService();

  private _authenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isAuthenticated());

  public get authenticationStatus(): Observable<boolean> {
    return this._authenticated.asObservable();
  }

  public get currentUser(): AdministrationUserDto {
    if (this.isAuthenticated()) {
      return JSON.parse(localStorage.getItem('currentUser'));
    }
    return null;
  };

  public get token(): string {
    if (this.isAuthenticated()) {
      return localStorage.getItem('token');
    }
    return null;
  }

  public get isAdministrator(): boolean {
    return this.currentUser?.roleName == "Administrator";
  }

  public get isManager(): boolean {
    return this.currentUser?.roleName == "Manager";
  }

  public get isUser(): boolean {
    return this.currentUser?.roleName == "User";
  }

  constructor(
    private router: Router,
    private apiAuthenticationService: ApiAuthenticationService,
  ) { }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    return token != null && !this.jwtHelper.isTokenExpired(token);
  }

  public isAllowed(roles: string[]): boolean {
    var result = false;
    if (this.isAuthenticated()) {
      const currentuser = this.currentUser;
      result = roles == null || roles.indexOf(currentuser.roleName) !== -1;
    } else {
      this.router.navigate(['/admin']);
    }
    return result;
  }

  public login(credentialsDto: LoginRequestDto): Observable<LoginResponseDto> {
    return this.apiAuthenticationService.login(credentialsDto)
      .pipe(
        map(response => {
          localStorage.setItem('token', response.token);
          this.setCurrentUser(response.currentUser);
          this._authenticated.next(this.isAuthenticated());
          console.log("login succeeded");
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  public setCurrentUser(user: AdministrationUserDto) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  public logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    this._authenticated.next(false);
    console.log("logout succeeded");
  }
}
